import React from "react";
import { Link } from "react-router-dom";

export const LogoMark = ({ light = false, size = 34 }) => (
  <span
    className={`inline-flex items-center justify-center rounded-full border ${light ? "border-[#F7F3EA]/50" : "border-[#183C35]/30"}`}
    style={{ width: size, height: size }}
  >
    <svg viewBox="0 0 24 24" width={size * 0.55} height={size * 0.55} fill="none">
      <path d="M4 7c3 1 5 4 8 11 3-7 5-10 8-11" stroke={light ? "#F7F3EA" : "#183C35"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 13c-1.6-1.4-2-3.4-1-5.6 1.9.6 2.7 2.4 1 5.6z" fill={light ? "#E3CBA5" : "#3E7F8E"} />
    </svg>
  </span>
);

const Logo = ({ light = false }) => (
  <Link to="/" className="flex items-center gap-2.5 group" data-testid="site-logo">
    <LogoMark light={light} />
    <span className="leading-none">
      <span className={`block font-serif-d font-bold text-[17px] ${light ? "text-[#F7F3EA]" : "text-[#183C35]"}`}>Aloha Corfu</span>
      <span className={`block text-[10px] tracking-[0.25em] font-medium mt-1 ${light ? "text-[#7FB8C4]" : "text-[#3E7F8E]"}`}>TRANSFERS &amp; TOURS</span>
    </span>
  </Link>
);

export default Logo;
